import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, MessageCircle, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const StickyCTA = ({ ctaData }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur-sm border-t border-border z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold text-foreground mb-1">
              {ctaData.title}
            </h3>
            <p className="text-sm text-muted-foreground">
              {ctaData.subtitle}
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3">
            {ctaData.buttons.map((button, index) => (
              <Button
                key={index}
                variant={button.variant === 'primary' ? 'default' : button.variant}
                size="sm"
                className="group"
                asChild
              >
                <Link to={button.action}>
                  {button.text}
                  {button.variant === 'primary' && (
                    <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  )}
                  {button.variant === 'secondary' && (
                    <ExternalLink className="ml-2 h-4 w-4" />
                  )}
                  {button.variant === 'tertiary' && (
                    <MessageCircle className="ml-2 h-4 w-4" />
                  )}
                </Link>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
